import React, { useEffect } from "react";
import text from "strings/text";
import filter from "./duck/filter";
import presenter from "./duck/presenter";

export function UserGroupComponent({ locationId, removeChannelFromUserDispatch, changeChannelForUserDispatch, addChannelToUserDispatch,  userPrivilege, channels}) {

  const selectGroup = (channel, oldGroup) => {
    if( oldGroup !== null) {
      changeChannelForUserDispatch(userPrivilege.userPrivilege.owner_id, oldGroup.id, channel.id);
    }else{
      addChannelToUserDispatch(userPrivilege.userPrivilege.owner_id, channel.id);
    }
  }

  const deleteGroup = (group) => {
    removeChannelFromUserDispatch(userPrivilege.userPrivilege.owner_id, group.id);
  }

  const channelRow = (channel, oldChannel) => {
    return (
        <li className='dropdown-li' key ={channel.id} onClick={() => selectGroup(channel, oldChannel) }> 
              <label> {channel.channel_name} </label><br/>
              <label className='count-li'> +{channel.member_count} members</label>
        </li>
    )
  }

  const editGroupRow = (group) => {
    return (
       <div className="edit-group-item" key={'edit-'+group.id}>
         <div>
            <button disabled={otherChannels.length == 0} id={'channel-row-'+group.id} data-bs-toggle="dropdown" aria-expanded="false" className={presenter.classNamesForGroupDropdown(otherChannels.length > 0)}>{group.channel_name}</button>
              <ul className="dropdown-menu" aria-labelledby={'channel-row-'+group.id}>
                {otherChannels.map((channel) => ( channelRow(channel, group)))}
              </ul>
         </div>

        <button className="remove-group" onClick={() => {deleteGroup(group)}}><img src="/icons/delete-corner.svg"/></button>
      </div>);
  }

  const userChannels = filter.channelsForUser(channels, userPrivilege);
  const otherChannels = filter.otherChannelsUserIsNotPartOf(channels, userPrivilege);

  return (
    <div className="user-group">
      <label className="section-label">{text.group}</label>
      <label className="section-explain">{text.groupExplain}</label>

        <div className="user-group-list">
          {userChannels.map((channel) => ( editGroupRow(channel)))}
        </div>

      <div>
         { true && <button disabled={otherChannels.length == 0} id='other-list' className="blue-btn" data-bs-toggle="dropdown" aria-expanded="false" > {text.addNewGroup}</button> }
          <ul className="dropdown-menu" aria-labelledby={'other-list'}>
              {otherChannels.map((channel) => ( channelRow(channel, null)))}
          </ul>
      </div>
    </div>
  );
}
export default UserGroupComponent;
